(function ($) {
  DJ.addBehavior('history', '.history__events', {
    attach: function () {
      const holder = this;
      const items = holder.querySelectorAll('.history-item');
      const events = holder.querySelectorAll('.history-event');
      const alignClass = 'history-event--align-right';

      if (items.length) {
        items[0].classList.add('history-item--first');
        items[items.length - 1].classList.add('history-item--last');
      }

      // Add class to odd elements to make right alignment.
      if (events.length) {
        const elementsArr = Array.prototype.slice.call(events);

        elementsArr.forEach((e, i) => {
          if (i % 2 === 0) {
            events[i].classList.add(alignClass);
          }
        });
      }
    }
  });
})(jQuery);
